import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {UncontrolledTooltip, Popover, PopoverHeader, PopoverBody } from 'reactstrap'
import {action, observable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import sessionStore from '../../../services/session/SessionStore';
import providersStore from "../../../services/providers/ProvidersStore";
import {SocialImage} from '../../../components/index';

import {PublishingStatus} from '../models';

@observer
class ReviewResponse extends Component {
  static propTypes = {
    response: PropTypes.object.isRequired,
    className: PropTypes.string,
    updateResponse: PropTypes.func,
    rejectResponse: PropTypes.func,
    removeResponse: PropTypes.func

  };
  static defaultProps = {
    className: "'"
  }

  @observable
  showRejectPopover = false;
  @observable
  rejectReason = "";

  @observable
  isEditing = false;
  @observable
  editResponse = "";

  @action
  toggleRejectPopover = () => {
    this.showRejectPopover = !this.showRejectPopover;
    this.rejectReason = "";
  };

  @action
  toggleIsEditing = () => {
    this.isEditing = !this.isEditing;
    if(this.isEditing){
      this.editResponse = this.props.response.detail;
    }else{
      this.editResponse = "";
    }
  };

  renderPublishingError(response) {
    return (
      <Fragment>
        <div className="badge badge-danger publishing-error mr-2">Publishing Error</div>&nbsp;
        <div className="ss-icon ss-refresh clickable mr-2" id={`retry-${response._id.$oid}`} onClick={() => this.props.updateResponse(response)} />
        <div className="ss-icon ss-delete clickable" id={`delete-${response._id.$oid}`} onClick={() => this.props.removeResponse(response)} />
        <UncontrolledTooltip placement="top" target={`retry-${response._id.$oid}`}>
          Retry Submission
        </UncontrolledTooltip>
        <UncontrolledTooltip placement="top" target={`delete-${response._id.$oid}`}>
          Remove
        </UncontrolledTooltip>
      </Fragment>
    );
  }
  //TODO - conditionally show controls
  // TODO - tooltip on delete
  render(){
    const {response, className, updateResponse, rejectResponse, removeResponse} = this.props;
    const isFromOwner = response.isFromOwner ? (<div className="badge badge-primary owner-response mr-2">Owner Response</div>) : undefined;

    let pendingApprovalBadge;
    let controls = [];
    let removeButton;
    if(response.publishingStatus === PublishingStatus.AWAITING_APPROVAL){
      pendingApprovalBadge = (<div className="badge badge-warning mr-2">Pending Approval</div>);
    }

    if(!this.isEditing && response.publishingStatus === PublishingStatus.AWAITING_APPROVAL && sessionStore.hasUserPermission('ApproveReviewResponse')){
      const rejectId = `reject-btn-${response._id.$oid}`;
      
      controls.push(<button key="approve-btn" type="button" className="btn btn-sm btn-success mr-2" onClick={() => updateResponse(response, true)}><span className="ss-icon ss-check mr-2" />Approve</button>);
      controls.push(<button key="reject-btn" id={rejectId} type="button" className="btn btn-sm btn-danger mr-2" onClick={this.toggleRejectPopover}><span className="ss-icon ss-deletecircle mr-2" />Reject</button>);
      controls.push(
        <Popover target={rejectId} placement="bottom" toggle={this.toggleRejectPopover} isOpen={this.showRejectPopover}>
          <PopoverHeader className="d-flex align-items-center">
            <span className="ss-icon ss-alert mr-3"/> Reject Response
          </PopoverHeader>
          <PopoverBody>
            <textarea rows={4} className="w-100 mb-2" value={this.rejectReason} onChange={(e) => runInAction(() =>  this.rejectReason = e.target.value)}>
            </textarea>
            <div style={{textAlign: "right"}}>
              <button key="reject-btn" id={rejectId} type="button" className="btn btn-sm btn-danger" onClick={() => rejectResponse(response, this.rejectReason)}><span className="ss-icon ss-deletecircle mr-2" />Reject</button>
            </div>
          </PopoverBody>
        </Popover>
      );
    }
    if(!this.isEditing && response.publishingStatus === PublishingStatus.AWAITING_APPROVAL && (sessionStore.hasUserPermission('SubmitReviewResponse') || sessionStore.hasUserPermission('ApproveReviewResponse'))) {
      const removeId = `remove-response-${response._id.$oid}`;
      controls.push(<button key="edit-btn" type="button" className="btn btn-outline-secondary btn-sm mr-2" onClick={this.toggleIsEditing}><i className="fas fa-edit"></i> Edit</button>)
      removeButton = (<div className="col">
        <button id={removeId} className="btn btn-secondary btn-sm" onClick={() => removeResponse(response)}><span className="ss-icon ss-delete" /> </button>
        <UncontrolledTooltip target={removeId}>
          Remove Response
        </UncontrolledTooltip>
      </div>);
    }

    const hasPublishingError = response.publishingStatus === PublishingStatus.ERROR || response.publishingStatus === PublishingStatus.UNHANDLED_ERROR ? this.renderPublishingError(response) : undefined;
    const userTitle = response.userTitle ? (<div>{response.userTitle}</div>) : undefined;
    return (
      <div className={`review-response ${className}`}>
        <div className="d-flex align-items-center response-title">
          {moment(response.date).format('MM/DD/YY')} - Comment from {response.username}&nbsp;
        </div>
        { !!(isFromOwner || hasPublishingError || pendingApprovalBadge) &&
          <div className="d-flex align-items-center mb-2">
            {isFromOwner}{hasPublishingError}{pendingApprovalBadge}
          </div>
        }
        <div className="d-flex align-items-stretch">
          <div className="response-image">
            <SocialImage size={30} userImage={response.imageURL} providers={providersStore.providers} />
          </div>
          <div className="w-100">
            <div className="">
              {userTitle}
              {!this.isEditing && response.detail}
              {
                this.isEditing && <Fragment>
                  <textarea rows={4} style={{width: "100%"}} onChange={(e) => runInAction(() => this.editResponse = e.target.value)} value={this.editResponse}> </textarea>
                  <button type="button" className="btn btn-sm btn-outline-secondary mr-1" onClick={this.toggleIsEditing}>Cancel</button>
                  <button type="button" className="btn btn-sm btn-secondary" onClick={() => { updateResponse( { ...response, detail: this.editResponse }, false ); this.toggleIsEditing(); }}>Save</button>
                </Fragment>
              }
            </div>
          </div>
          {removeButton}
        </div>
        {!!controls.length && <div className="row card-spacer-top">
          <div className="col">
            {controls}
          </div>
        </div>}
      </div>
    );
  }
}
export default ReviewResponse;
